import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WsbFrontendService {
  public wsbRouter = new Subject<string>();

  constructor(private router: Router) {
    this.router.events.subscribe(routerEvent => {
      if (routerEvent instanceof NavigationEnd) {
        this.notifyNewWsbRoute(routerEvent.url);
      }
    });
  }

  public notifyNewWsbRoute(url: string): void {
    this.wsbRouter.next(url);
  }

  // public getLoginStatus(): void {
  //   this.http.get<PhpUser>(`/s/ajax/user/atlas-authenticate`).subscribe(user => {
  //     if (user && user.idUser && user.token) {
  //       if (!this.userService.isImpersonatingSubuser()) {
  //         this.sessionStorage.store('wsb-user-key', user.idUser);
  //         this.sessionStorage.store('wsb-userprofile-key', user.idUserProfile);
  //         this.sessionStorage.store('wsb-access-token', user.token);
  //         // this.sessionStorage.store('wsb-userprofile-role', user.idRole);
  //       }

  //       this.userService.identity(true).subscribe(angularUser => {
  //         if (angularUser === null) {
  //           this.router.navigate(['login']);
  //         }
  //       });
  //     } else {
  //       this.router.navigate(['login']);
  //     }
  //   });
  // }
}
